module.exports = __webpack_public_path__ + "media/images/icons/outlined/yuque-03ef11ad6609b94d55e910f86a5606ce.svg";